module.exports = __webpack_public_path__ + "img/brands-pan-school.jpg?389e7c2db73b5edffe0fd3b3282b446a";